import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消确认")

import { ref, Ref, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import store from '@/store/index'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { 
  'POST/checkin/month_detail': fetchList,
  // 考勤详情确认
  'PATCH/checkin/confirm': confirmApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 获取所有非注销公司
  'GET/company/active': companyApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height 
} = new tbMix(fetchList)

let userRows: any = ref([])
const lockFg = ref<boolean>(false)
const fetchHandle = async (params: object) => {
  let { locked } = await fetchData(params, {}, 1)
  lockFg.value = locked
}

const searchConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: dayjs().subtract(0, 'month').format('YYYY-MM') + '-01',
    upKey: 'date',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD'
    }
  },
  {
    label: "姓名",
    value: '',
    upKey: 'key',
    props: { clearable : true }
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: organizationsApi,
    props: { placeholder: '请选择团队', clearable: true },
    seleProps: {
      label: 'name',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    selectType: 'GROUP',
    label: '公司',
    value: '',
    upKey: 'companyIds',
    // selectFunc: companyApi,
    options: store.getters.sysCompany,
    props: { clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 350px', placeholder: '请选择公司', },
    seleProps: { label: 'name', valueName: 'id',}
  },
  {
    type: 'SELECT',
    label: 'hr确认状态',
    value: 0,
    upKey: 'locked',
    options: [
      { label: '已确认', id: 1 }, 
      { label: '未确认', id: 0 }, 
    ],
    props: {clearable: true, placeholder: '请选择hr确认状态',},
    seleProps: {}
  },
  {
    type: 'SELECT',
    label: '员工确认状态',
    value: '',
    upKey: 'invalid',
    options: [
      { label: '已确认', id: '已确认' }, 
      { label: '未确认', id: '未确认' }, 
    ],
    props: {clearable: true, placeholder: '请选择员工确认状态',},
    seleProps: {}
  },
  {
    type: 'SELECT',
    label: '全勤奖',
    value: '',
    upKey: 'type',
    options: [
      { label: '全勤奖', id: '全勤奖' }, 
    ],
    props: {clearable: true, placeholder: '请选择员工确认状态',},
    seleProps: {}
  },
])


const submitHandle = (fg: boolean) => {

  let userIds = userRows.value.map((_user: any) => {
    return _user.userId
  })


  let str = fg ? '请确认考勤详情:' : '请取消确认考勤详情:'
  ElMessageBox.confirm(
    str + dayjs(MI_params.date).format('YYYY-MM'),
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return confirmApi({date: MI_params.date, locked: fg, userIds})
      
    })
    .then(() => {
      MI_identify.value = false
      ElMessage({
        type: 'success',
        message:  fg ? '确认成功' : '取消确认成功',
      })
      fetchHandle(MI_params)
    })
    .catch(() => {
      MI_identify.value = false

    })
}

// -----
const formatDeatils = (rowArr: any, label: string) => {
  let obj = rowArr.find( (details: any) => details.label === label)
  return obj ? obj.time : '-'
  
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "考勤详情-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: fetchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    })), [
      [_directive_permission, void 0, "checkin"]
    ]),
    (!lockFg.value)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "success",
          class: "mt-10",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (submitHandle(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })), [
          [_directive_permission, void 0, "checkin"]
        ])
      : _createCommentVNode("", true),
    (lockFg.value)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "danger",
          class: "mt-10",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (submitHandle(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })), [
          [_directive_permission, void 0, "checkin"]
        ])
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[2] || (_cache[2] = (files) => { _isRef(userRows) //@ts-ignore
 ? userRows.value = files : userRows = files}),
      "max-height": _unref(MI_height) - 60 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50"
        }),
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(`${ row.realName }(${row.alias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "全勤奖",
          prop: "FullAwardAmount",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "迟到早退(分钟)",
          prop: "absenceMinutes",
          align: "right",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "事假(小时)",
          prop: "compassionateTime",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "病假(小时)",
          prop: "sickTime",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          label: "加班换薪",
          prop: "overtimeSalary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "总时长",
              prop: "overtimeSalary.totalTime",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "工作日",
              formatter: (row) => formatDeatils(row.overtimeSalary.detailList, '工作日'),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "假日",
              formatter: (row) => formatDeatils(row.overtimeSalary.detailList, '假日'),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "节日",
              formatter: (row) => formatDeatils(row.overtimeSalary.detailList, '节日'),
              align: "right"
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "调休假换薪",
          prop: "adjustSalary"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "总时长",
              prop: "adjustSalary.totalTime",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "工作日",
              formatter: (row) => formatDeatils(row.adjustSalary.detailList, '工作日'),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "假日",
              formatter: (row) => formatDeatils(row.adjustSalary.detailList, '假日'),
              align: "right"
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "节日",
              formatter: (row) => formatDeatils(row.adjustSalary.detailList, '节日'),
              align: "right"
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "年假换薪(小时)",
          prop: "annualTime",
          align: "right",
          width: "150"
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})